'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const SvgVeg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#Veg12_svg__clip0_32982_71545)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 10.95C4.5561 10.95 3.57881 10.9478 2.84809 10.8495C2.14759 10.7553 1.83287 10.5906 1.62114 10.3789C1.40941 10.1671 1.24465 9.85241 1.15047 9.15191C1.05223 8.42119 1.05 7.4439 1.05 6C1.05 4.5561 1.05223 3.57881 1.15047 2.84809C1.24465 2.14759 1.40941 1.83287 1.62114 1.62114C1.83287 1.40941 2.14759 1.24465 2.84809 1.15047C3.57881 1.05223 4.5561 1.05 6 1.05C7.4439 1.05 8.42119 1.05223 9.15191 1.15047C9.85241 1.24465 10.1671 1.40941 10.3789 1.62114C10.5906 1.83287 10.7553 2.14759 10.8495 2.84809C10.9478 3.57881 10.95 4.5561 10.95 6C10.95 7.4439 10.9478 8.42119 10.8495 9.15191C10.7553 9.85241 10.5906 10.1671 10.3789 10.3789C10.1671 10.5906 9.85241 10.7553 9.15191 10.8495C8.42119 10.9478 7.4439 10.95 6 10.95ZM0 6C0 3.17157 0 1.75736 0.87868 0.87868C1.75736 0 3.17157 0 6 0C8.82843 0 10.2426 0 11.1213 0.87868C12 1.75736 12 3.17157 12 6C12 8.82843 12 10.2426 11.1213 11.1213C10.2426 12 8.82843 12 6 12C3.17157 12 1.75736 12 0.87868 11.1213C0 10.2426 0 8.82843 0 6ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z", fill: "#0F8A65" })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "Veg12_svg__clip0_32982_71545" },
            React__namespace.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(12 12) rotate(-180)" })))));

exports.default = SvgVeg12;
//# sourceMappingURL=Veg12.js.map
